import React from 'react';
import { Box, Button, Grid, RiAddBoxLine } from '@itandi/itandi-bb-ui';
import SettingStyles from '../SettingStyle.module.scss';
import { useSessions } from '~/hooks/vendors/useSessions';
import { useLineUserAccounts } from '~/hooks/vendors/useLineUserAccounts';
import { LineUserAccountList } from '~/components/common/line_user_accounts/LineUserAccountList';
import { LineUserAccountModal } from '~/components/common/line_user_accounts/LineUserAccountModal';
import { useOpenHandler } from '~/hooks/useOpenHandler';
import type { NskResponse } from '~/models/Api';
import type { LineUserAccountEdit } from '~/models/LineUserAccount';
import { create, update, destroy } from '~/utils/api/vendors/LineUserAccounts';

export const LineUserAccounts: React.FC = () => {
  const { data: session } = useSessions().index();
  const { data: lineUserAccounts, mutate: mutateLineUserAccounts } =
    useLineUserAccounts().index();
  const {
    isOpen: openLineUserAccountModal,
    handleOpen: handleOpenLineUserAccountModal,
    handleClose: handleCloseLineUserAccountModal
  } = useOpenHandler();
  const handleCreate = React.useCallback(
    async (lineUserAccountEdit: LineUserAccountEdit): Promise<NskResponse> =>
      create(lineUserAccountEdit),
    []
  );
  const handleUpdate = React.useCallback(
    async (
      lineUserAccountEdit: LineUserAccountEdit,
      lineUserAccountId: number
    ): Promise<NskResponse> => update(lineUserAccountEdit, lineUserAccountId),
    []
  );
  const handleDestroy = React.useCallback(
    async (lineUserAccountId: number): Promise<NskResponse> =>
      destroy(lineUserAccountId),
    []
  );
  const handleMutate = React.useCallback(async () => {
    await mutateLineUserAccounts?.();
  }, [mutateLineUserAccounts]);
  if (session === null || lineUserAccounts === null) {
    return null;
  }
  return (
    <>
      <Grid autoFlow="column" justifyContent="space-between">
        <Box>
          <h3 className={SettingStyles.SettingTitle}>LINEアカウント設定</h3>
        </Box>
        <Box>
          <Button
            onClick={handleOpenLineUserAccountModal}
            startIcon={<RiAddBoxLine />}
          >
            追加
          </Button>
        </Box>
      </Grid>
      <LineUserAccountList
        handleDestroy={handleDestroy}
        handleMutate={handleMutate}
        handleUpdate={handleUpdate}
        lineUserAccounts={lineUserAccounts.lineUserAccounts}
      />
      <LineUserAccountModal
        handleClose={handleCloseLineUserAccountModal}
        handleCreate={handleCreate}
        handleMutate={handleMutate}
        isOpen={openLineUserAccountModal}
      />
    </>
  );
};
